import Swiper from 'swiper/';
import Navigation from 'swiper/modules/navigation.min.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';
import Scrollbar from 'swiper/modules/scrollbar.min.mjs';
window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Scrollbar = Scrollbar;

// Плавный (инерционный) скролл. Готовая сборка сама кладёт класс в globalThis.Lenis.
import 'lenis/dist/lenis.min.js';

// import Cookies from 'js-cookie'
// window.Cookies = Cookies

// require("suggestions-jquery")
